/*
 * @Date: 2024-08-19 13:44:31
 * @LastEditors: Mipawn dongzhan@mipawn.com
 * @LastEditTime: 2024-08-27 20:27:11
 * @Author: Mipawn
 * @Description: watsApp 弹窗
 */
import 'swiper/css';

import { Button } from '@mui/material';
import { useRequest } from 'ahooks';
import classNames from 'classnames';
import dayjs from 'dayjs';
import Decimal from 'decimal.js';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import SlotCounter from 'react-slot-counter';
import { Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import { implog } from '@/api/implog';
import { getCashoutHistoryList } from '@/api/share';
import BlurryLoadingImage from '@/components/progressive-img';
import WhatsappMoney from '@/pages/whatsapp/assets/money.webp';
import { modalStore } from '@/stores/modal';
import { getAvatar } from '@/utils/img';

import styles from './activate.module.less';

const ActivateV2 = (modal, onClose, { score, cash_can, animate = false }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [progress, setProgress] = useState(0);
  const [scoreText, setScoreText] = useState('');
  const amountRef = useRef<any>(null);
  const tipRef = useRef<any>(null);

  const { data: list = [] } = useRequest(async () => {
    const { record } = await getCashoutHistoryList();
    return (record || []).map(item => {
      return {
        ...item,
        rdate: dayjs(item.rdate).format('DD/MM HH:mm')
        // imageIndex: generateHashFromText(`${item.userid}`) % 10
      };
    });
  });

  const TipText = () => {
    if (cash_can === 5 || score > 40) {
      return (
        <span>
          Withdraw $<span className={styles.hightLight}>{cash_can}</span> now.
        </span>
      );
    }
    const value = Decimal.sub(40, score || 0).toFixed(2);
    const startVal = value.length <= 4 ? '9.99' : '20.00';
    return (
      <span>
        <span className={styles.tip_number}>Only $</span>
        {animate ? (
          <span className={styles.hightLight}>
            <SlotCounter
              startValue={startVal}
              direction="top-down"
              ref={tipRef}
              autoAnimationStart={false}
              value={value}
              numberClassName={styles.hightLight}
              separatorClassName={styles.hightLight}
              charClassName={styles.hightLight}
              valueClassName={styles.hightLight}
              containerClassName={styles.amount_num_container}
            />
          </span>
        ) : (
          <span className={styles.hightLight}>{value}</span>
        )}

        <span className={styles.tip_number}>&nbsp; more to initiate a withdrawal</span>
      </span>
    );
  };

  const buttonText = useMemo(() => {
    if (cash_can === 5 || score > 40) {
      return 'Withdraw';
    }
    return 'Earn more bonuses to withdraw';
  }, [score, cash_can]);

  const getUserId = userId => {
    return `${userId}`.replace(/^(\w{2})(\w+)(\w{2})$/, (_, p1, p2, p3) => `${p1}${'*'.repeat(p2.length)}${p3}`);
  };

  useEffect(() => {
    let width = 100;
    if (score < 40) {
      width = (score / 40) * 100;
    }
    if (cash_can === 5) {
      width = 100;
    }
    // 为了能看到动画
    setProgress(width);
  }, [score, cash_can]);

  useEffect(() => {
    setScoreText(new Decimal(score).toFixed(2));
  }, [cash_can, score]);

  // 为了动画和 文字对齐做的，但是不知道原因，目前是测试出来这样可以
  useEffect(() => {
    setTimeout(() => {
      amountRef.current?.refreshStyles();
      amountRef.current?.startAnimation();
    }, 200);
  }, [amountRef.current]);
  useEffect(() => {
    setTimeout(() => {
      tipRef.current?.refreshStyles();
      tipRef.current?.startAnimation();
    }, 200);
  }, [tipRef.current]);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <BlurryLoadingImage src={WhatsappMoney} />
        <span>Get Free Withdrawal Access</span>
      </div>

      <div className={styles.brand}>
        <span>WITHDRAWAL NOW</span>
      </div>

      <div className={styles.title}>How lucky you are!</div>
      <div className={styles.amount}>
        <span className={styles.amount_number}>$&nbsp;</span>
        {animate ? (
          <SlotCounter
            ref={amountRef}
            startValue="00.00"
            value={scoreText}
            autoAnimationStart={false}
            numberClassName={styles.amount_number}
            separatorClassName={styles.amount_number}
            charClassName={styles.amount_number}
            valueClassName={styles.amount_number}
            containerClassName={styles.amount_num_container}
          />
        ) : (
          <span className={styles.amount_number}>{scoreText}</span>
        )}
      </div>

      <div className={styles.progress}>
        <div
          className={classNames(styles.progress_bar, { [styles.animation]: animate })}
          style={{ width: `${progress}%` }}
        />
        <div className={styles.progress_num}>{progress?.toFixed(2)}%</div>
      </div>
      <div className={styles.tip}>
        <TipText />
      </div>

      <div className={styles.button}>
        <Button
          className="global_button_succes"
          onClick={() => {
            if (pathname === '/game') {
              modalStore.closeTaskChain();
            }
            if (pathname === '/share') {
              modal.resolve({ onClose });
              return;
            }
            implog('wa_activate_btn_click');
            navigate('/share');
            // onClose?.();
          }}
        >
          {buttonText}
        </Button>
      </div>

      <div>
        {!!list.length && (
          <Swiper
            className={styles.marquee}
            modules={[Autoplay]}
            slidesPerView={5}
            slidesPerGroup={5}
            loop={true}
            direction="vertical"
            autoplay={{
              delay: 2000,
              disableOnInteraction: false
            }}
          >
            {list.map((item, index) => {
              return (
                <SwiperSlide key={index}>
                  <div className={styles.marquee_item}>
                    <div className={styles.marquee_start}>
                      <BlurryLoadingImage src={getAvatar(item.face_512 || item.userid)} />
                      <span className={styles.marquee_id}>{getUserId(item.userid)}</span>
                    </div>
                    <div className={styles.marquee_cash}>$ {item?.cash}</div>
                    <div className={styles.marquee_time}>{item.rdate}</div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        )}
      </div>
    </div>
  );
};

export default ActivateV2;
